<template>
  <div>
    <br>
      <b-row class="justify-content-md-center">    
        <b-form>
          <b-row>
            <b-col md="4">
              <Label>Participant Name:</label>
            </b-col>
            <b-col md="5">
              <b-form-input v-model="$v.participantName.$model" :state="participantNameState"></b-form-input>
              </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <Label>Birthdate:</label>
            </b-col>
            <b-col md="5">
              <b-form-group description="e.g.05-30-97">
                <b-form-input v-model="$v.participantBirthDate.$model" v-mask="'##-##-##'" :state="participantBirthDateState"></b-form-input>
              </b-form-group>
              </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <label>Participant Contact Information - <strong>Must provide at least a telephone number</strong></label>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col md="4">
              <Label>Telephone Number:</label></b-col>
            <b-col md="5">
              <b-form-input v-model="$v.participantPhone.$model" v-mask="'###-###-####'" :state="participantPhoneState"></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <Label>Email Address:</label></b-col>
            <b-col md="5">
              <b-form-input v-model="$v.participantEmail.$model" :state="participantEmailState"></b-form-input>
            </b-col>
          </b-row>
          <hr />
            <h5>Participant Reference Code</h5>
          <b-row>
            <b-col md="4">
              <label>Reference Code:</label>
            </b-col>
            <b-col md="5">
                <b-form-input id="txtReferenceCode" v-model="$v.referenceCode.$model" :state="referenceCodeState" ></b-form-input>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="8" offset="2" >
              <label>First 3 letters of last name and birth month and day</label>
              <label>(e.g. John Smith May 3, 2000 - SMI0503)</label>
            </b-col>
          </b-row>
        </b-form>
      </b-row>   
      <hr>       
      <nav class="navbar fixed-bottom survey-nav-buttons">

        <b-row class="pt-3 w-100">
          <b-col sm="2">
            <b-btn
              variant="outline-primary"
              size="lg"
              class="w-120"
              :to="{path: '/'}"
              >Cancel</b-btn
            >
          </b-col>
          <b-col sm="8">
            <div v-if="ShowErrorMsg">             
              <font-awesome-icon icon="exclamation-triangle" class="fa-2x"/>   
              <span class="error-message">All fields are required!</span>
              </div>
          </b-col>
          <b-col sm="2">
            <b-btn
              variant="primary"
              size="lg"
              class="w-120"
              @click="moveNext"
              >Next</b-btn
            >
          </b-col>
        </b-row>
      </nav>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { format } from "path";
library.add(fas)

export default {
  name: "ParticipantPin",
  props: ["surveyData", "isValid"],
  components: {
    FontAwesomeIcon
  },
  data: () => ({
    participantName: "",
    participantEmail: "",
    participantPhone: "",
    participantBirthDate: "",
    referenceCode: null,
    isInvalid: true,
    ShowErrorMsg: false
  }),
  validations: {
    participantName: {
      required
    },
    participantPhone: {
      required
    },    
    participantEmail: {
      required
    },
    participantBirthDate: {
      required
    },
    referenceCode: {
      required
    }
  },
  methods: {
    moveNext() {
      if (!this.$v.$invalid) {
        this.$emit("move-next", {
          name: this.participantName,
          phone: this.participantPhone,
          email: this.participantEmail,
          birthdate: this.participantBirthDate,
          referenceCode: this.referenceCode,
          isValid: true
        });
        this.referenceCode = null; //reset the value to null for the next survey
      } else {
        this.showErrorMsg = true;
        this.$v.$touch();
      }

    },
    onCreated() {
      this.participantName = this.surveyData.FirstAndLastName;
      this.participantEmail = this.surveyData.EmailAddress;
      this.participantPhone = this.surveyData.TelephoneNumber;
      this.participantBirthDate = this.surveyData.ParticipantBirthdate;
    }
  },
  computed: {
    
    participantNameState () {
      return this.$v.participantName.$dirty ? this.$v.participantName.required : null;
    },    
    participantEmailState () {
      return this.$v.participantEmail.$dirty ? this.$v.participantEmail.required : null;
    },    
    participantPhoneState () {
      return this.$v.participantPhone.$dirty ? this.$v.participantPhone.required : null;
    },
    participantBirthDateState () {
      return this.$v.participantBirthDate.$dirty ? this.$v.participantBirthDate.required : null;
    },
    referenceCodeState () {
      return this.$v.referenceCode.$dirty ? this.$v.referenceCode.required : null;
    }
  },
  watch: {
   referenceCode() {
     if(this.referenceCode != undefined && this.referenceCode != null && this.referenceCode != '')
        this.referenceCode = this.referenceCode.toUpperCase();
    }
  },
  mounted() {
    this.onCreated();
  }
};
</script>

<style scoped>
.navbar{
  background-color: #ffffff;
}
.survey-nav-buttons{
  padding-bottom: 60px;
}
.row{
  padding-bottom: 10px;
}
.fa-exclamation-triangle{
  color: red;
}
.error-message{
  color: red;
  font-size: 1.5em;
  padding-left: 10px;
}
</style>